import { render, staticRenderFns } from "./FormCISAccount.vue?vue&type=template&id=ab6b18dc&scoped=true"
import script from "./FormCISAccount.vue?vue&type=script&lang=js"
export * from "./FormCISAccount.vue?vue&type=script&lang=js"
import style0 from "./FormCISAccount.vue?vue&type=style&index=0&id=ab6b18dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6b18dc",
  null
  
)

export default component.exports